var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isVisible
      ? _c("div", { staticClass: "jProgressScreen" }, [
          _c(
            "div",
            {
              staticClass: "notification-screen",
              attrs: { id: "progress-screen" }
            },
            [
              _c(
                "div",
                { staticClass: "floating-container" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("h1", { attrs: { id: "progress-screen-data" } }, [
                    _vm._v(
                      "Processing " +
                        _vm._s(_vm.retrievedData.length) +
                        "/" +
                        _vm._s(_vm.max)
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-progress",
                    { staticClass: "mb-3", attrs: { max: _vm.max } },
                    [
                      _c("b-progress-bar", {
                        attrs: { value: _vm.numOfFailed, variant: "danger" }
                      }),
                      _vm._v(" "),
                      _c("b-progress-bar", {
                        attrs: { value: _vm.numOfSuccess, variant: "success" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "progress-screen-message" } }, [
                    _c("span", { staticClass: "span__success--green" }, [
                      _vm._v(_vm._s(_vm.numOfSuccess) + " data success")
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "span_failed--red" }, [
                      _vm._v(_vm._s(_vm.numOfFailed) + " data failed")
                    ]),
                    _vm._v(" "),
                    _vm.getErrorDatas.length > 0
                      ? _c(
                          "div",
                          { attrs: { id: "progress-message-container" } },
                          [
                            _c("p", [_vm._v("Problem Message:")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { attrs: { id: "box" } },
                              _vm._l(_vm.getErrorDatas, function(
                                errorData,
                                index
                              ) {
                                return _c("p", { key: index }, [
                                  _vm._v(
                                    "\n                - Data " +
                                      _vm._s(errorData.index) +
                                      ": " +
                                      _vm._s(errorData.message) +
                                      ".\n              "
                                  )
                                ])
                              })
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.finish
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            id: "progress-screen-finish",
                            variant: "success"
                          },
                          on: { click: _vm.toggleIsVisible }
                        },
                        [_vm._v("\n          Finish\n        ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-check-circle" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10ea73c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10ea73c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress-screen/jProgressScreen.vue
// module id = null
// module chunks = 